<template>
  <div class="ba-card ba-w-100">
    <div class="ba-flex ba-jc-sb ba-ai-center ba-w-100">
      <span class="ba-title ba-h-100 ba-ai-center">
        {{ $t("ct-website-overview") }}
      </span>
    </div>
    <hr class="ba-hr-row">
    <br>
    <div class="ba-content ba-grid ba-gp-1">
      <overview></overview>
    </div>
  </div>
</template>

<script>
import Overview from '../pages/Overview.vue';
export default {
  name: "Analytics",
  components: {Overview}
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/Analytics.vue